import { Helper } from '@/mixin/helper'
import store from '@/state/store'

export default [
  {
    path: '/help/',
    name: 'help',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess']([
            'help_login:read',
            'help_dasbor:read',
            'help_default:read',
            'help_notifikasi:read',
            'help_pengaturan:read',
            'help_masterdata:read',
            'help_pelacakanvideo:read',
            'help_penilaianpengemudi:read',
            'help_lisensi:read',
            'help_laporan:read',
            'help_pelacakansementara:read',
            'help_bantuandankontakkami:read',
            'help_kendaraan:read',
            'help_karyawan:read',
            'help_pengguna:read',
            'help_grupkendaraan:read',
          ])
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/help/'),
  },

  {
    path: '/contactus/',
    name: 'Contact Us',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (
          store.getters['identity/hasAccess'](['contact:read']) ||
          (
            store.getters['identity/hasAccessAll'](['tms_driver:read','tms_driver:update']) && 
            !store.getters['identity/hasAccess'](['vgroups:read'])
          )
        ) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
        next()
      },
    },
    component: () => import('@/router/views/contactus/'),
  },

  {
    path: '/logs/',
    name: 'User Logs',
    meta: {
      authRequired: true,
      hasAccess: true,
      beforeResolve(_, routeFrom, next) {
        Helper.methods.userLogging('Access', _)
        if (store.getters['identity/hasAccess'](['c14a-user-action-log:read'])) {
          next()
        } else {
          next({ name: 'Liveview' })
        }
      },
    },
    component: () => import('@/router/views/log/'),
  },

  {
    path: '/components/:name',
    name: 'Components',
    meta: {
      authRequired: false,
      hasAccess: process.env.VUE_APP_ENV === 'development' ? true : false,
    },
    component: () => import('@/router/components'),
  },
]
